import { Award, GraduationCap } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { CREDENTIALS } from "@/data/content";

export default function Certifications() {
  return (
    <section id="credentials" data-testid="credentials-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          label="Certifications & Education"
          title="Trained, certified,"
          accent="always learning"
          testId="credentials-heading"
        />

        <div className="grid gap-6 md:grid-cols-2" data-testid="credentials-list">
          {CREDENTIALS.map((cred, i) => {
            const Icon = cred.kind === "education" ? GraduationCap : Award;
            return (
              <Reveal key={cred.name} delay={0.06 * i}>
                <div className="flex h-full items-start gap-5 rounded-2xl border border-white/10 bg-white/[0.02] p-7 transition-[border-color,transform] duration-300 hover:-translate-y-1 hover:border-electric/40">
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-electric/30 bg-electric/10 text-electric">
                    <Icon size={22} aria-hidden="true" />
                  </div>
                  <div>
                    <h3 className="font-display text-lg font-semibold uppercase tracking-tight text-neutral-100">{cred.name}</h3>
                    <p className="mt-1 text-sm font-semibold text-neutral-300">{cred.issuer}</p>
                    <p className="mt-1 text-xs font-bold uppercase tracking-[0.2em] text-electric">{cred.detail}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
